import React from "react";
import { useTranslation } from "react-i18next";
import { FaTrash } from "react-icons/fa";
import { FaTimes } from "react-icons/fa";

interface ModalConfirmationProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;

}

const ModalConfirmation: React.FC<ModalConfirmationProps> = ({ isOpen, onClose, onConfirm }) => {
  const { t } = useTranslation()
  if (!isOpen) return null; // Don't render the modal if it's not open

  return (
    <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex items-center justify-center">
      <div className="bg-white p-8 rounded-md shadow-lg w-1/3 sm:w-2/5 lg:w-1/3">
        <h2 className="text-xl mb-4">
          {t(`delete.deleteMessage`)}
        </h2>
        <div className="flex justify-end mt-4">
          <button
            onClick={onClose}
            className="flex items-center mr-4 justify-center bg-gray-600 text-white hover:bg-gray-700 rounded-full w-12 h-12 text-2xl"
          >
            <FaTimes />
          </button>
          <button
            onClick={onConfirm}
            className={`bg-red-600 hover:bg-red-700 rounded-full text-white px-6 py-3 rounded-md`}
          >
            <FaTrash className="text-2xl" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalConfirmation;
